import React from "react"
import { Modal, Form, Col, Row, Button } from "react-bootstrap"
import { toast } from "react-toastify"
import { InvitationStatus } from "../../api/Invitation/Model/InvitationStatus"

import ValidatePIN from "./ValidatePIN"
import GetOneTimePIN from "../../api/Invitation/GetOneTimePIN"

import InvitationStatusGridRecord from "../../api/InvitationStatus/Model/InvitationStatusGridRecord"

interface ValidateIdentityProps {
  currentURL: string
  data: InvitationStatusGridRecord
  status: InvitationStatus
  userPhoneNumber?: string
  userEmail?: string
  onSuccess: (pin: string, outboxAN: number) => void
}

interface ValidateIdentityState {

  showContactForm: boolean
  showSendPin: boolean
  showValidatePIN: boolean
  showLinkExpired: boolean
  showTooManyAttempts: boolean
  method: string
}

const InvitationPage = (props: { title: string, children?: JSX.Element | JSX.Element[] }) => <Modal.Dialog size="xl">
  <Modal.Header>
    <Modal.Title className="text-uppercase">{props.title}</Modal.Title>
  </Modal.Header>
  { props.children }
</Modal.Dialog>

export default class ValidateIdentity extends React.PureComponent<ValidateIdentityProps, ValidateIdentityState> {
  userMobileNumber: string = this.props.userPhoneNumber || ""
  currentOutboxAN: number = this.props.data.OutboxAN

  state: ValidateIdentityState = {
    showContactForm: [
      InvitationStatus.PENDING,
      InvitationStatus.STARTED,
      InvitationStatus.INVITATION_IN_USE].includes(this.props.status),
    showSendPin: false,
    showValidatePIN: this.props.status === InvitationStatus.VALIDATE_PIN,
    showLinkExpired: this.props.status === InvitationStatus.EXPIRED,
    showTooManyAttempts: this.props.status === InvitationStatus.TOO_MANY_ATTEMPT,
    method: "EMAIL"
  }

  getOneTimePIN = () => {
    const data = {
      Link: this.props.currentURL,
      method: this.state.method
    }
    this.setState({showSendPin: false})
    GetOneTimePIN(data).subscribe(
      data => this.getOneTimePinSuccess(data),
      error => this.getOneTimePinError(error)
    )
  }

  getOneTimePinSuccess(data: number) {
    this.currentOutboxAN = data
    this.setState({ showContactForm: false, showValidatePIN: true })
    toast.success("PIN sent successfully")
  }

  getOneTimePinError(message: string) {
    toast.error(message)
  }

  setMethod = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ method: event.target.value })
  }

  render() {
    const userPhoneNumber = this.userMobileNumber
    const { showContactForm, showSendPin, showLinkExpired, showTooManyAttempts } = this.state
    const showByVoice = this.props.status !== InvitationStatus.INVITATION_IN_USE 

    return (
      <>
        { showLinkExpired && <InvitationPage title="Your Link is expired. Please contact with the Site Administrator." />}
        { showContactForm && <InvitationPage title="How Should We Contact You">
          <Modal.Body>
            <Row><Col><p>To proceed, we need to provide you with a PIN:</p></Col></Row>
            <Row>
              <Col sm={4} className="d-flex justify-content-end font-weight-bold">Your information:</Col>
              <Col sm={1} className="font-weight-bold">Phone:</Col>
              <Col className="font-weight-bold">{ userPhoneNumber?.substring(0,3) }-{ userPhoneNumber?.substring(3,6) }-{ userPhoneNumber?.substring(6,10) }</Col>
            </Row>
            <Row>
              <Col sm={4}></Col>
              <Col sm={1} className="font-weight-bold">eMail:</Col>
              <Col className="font-weight-bold">{ this.props.userEmail }</Col>
            </Row>
            <Row><Col><p>Please indicate how we should contact you:</p></Col></Row>
            <Row className="d-flex justify-content-center">
              <Col md="auto">
                <Form.Check type="radio" name="contactOption" id="contactEmail" value="EMAIL" label="By eMail" className="abc-radio" defaultChecked onChange={this.setMethod}/>
              </Col>
              <Col md="auto">
                <Form.Check type="radio" name="contactOption" id="contactText" value="TEXT" label="Via Text Message" className="abc-radio" onChange={this.setMethod}/>
              </Col>
              {showByVoice && (
                <Col md="auto">
                  <Form.Check type="radio" name="contactOption" id="contactVoice" value="VOICE" label="By Voice" className="abc-radio" onChange={this.setMethod}/>
                </Col>
              )}
            </Row>
            <Row className="buttons-block form-row">
              <Button variant="primary" className="mr-2" onClick={this.getOneTimePIN}>Send</Button>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <em>  *** Message and data rates may apply. 1 message per user request. For terms: <a href="https://www.formfox.com/SMSTermsOfService"> https://www.formfox.com/SMSTermsOfService </a>. For privacy: <a href="https://www.formfox.com/PrivacyPolicy"> https://www.formfox.com/PrivacyPolicy</a>. Text HELP to 52141 for help. Text STOP to 52141 to stop receiving texts. *** </em>
          </Modal.Footer>
        </InvitationPage> }
        { showSendPin && <InvitationPage title="Confirmation Pin">
          <Modal.Body>
            <Row><Col><p>A PIN must be texted to you for security confirmation:</p></Col></Row>
            <Row className="buttons-block form-row">
              <Button variant="primary" className="mx-auto" onClick={this.getOneTimePIN}>TEXT PIN</Button>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <em>  *** Message and data rates may apply. 1 message per user request. For terms: <a href="https://www.formfox.com/SMSTermsOfService"> https://www.formfox.com/SMSTermsOfService </a>. For privacy: <a href="https://www.formfox.com/PrivacyPolicy"> https://www.formfox.com/PrivacyPolicy</a>. Text HELP to 52141 for help. Text STOP to 52141 to stop receiving texts. *** </em>
          </Modal.Footer>
        </InvitationPage> }
        { showTooManyAttempts && <InvitationPage title="Too Many Attempts to Accept Invitation">
          <Modal.Body>
            <Row><Col><p>Our Apologies!</p></Col></Row>
            <Row><Col><p>For security purposes, we limit the number of times an invitation may be accepted.</p></Col></Row>
            <Row><Col><p>In order to continue, your administrator will need to re-invite you. We have flagged your invitation to your administrator's attention.</p></Col></Row>
            <Row><Col><p>To expedite this process, please contact your administrator for assistance.</p></Col></Row>
          </Modal.Body>
        </InvitationPage> }
        { this.state.showValidatePIN && <ValidatePIN currentURL={this.props.currentURL} outboxAN={this.currentOutboxAN} onSuccess={(pin: string) => this.props.onSuccess(pin, this.currentOutboxAN)} onBack={() => this.setState({ showValidatePIN: false, showContactForm: true }) } /> }
      </>
    )
  }
}
